import { jsx as _jsx } from "react/jsx-runtime";
import { Text } from '@dixa/lib-shared-habla';
import classNames from 'classnames';
import isNumber from 'lodash/isNumber';
import { memo, useMemo, useState } from 'react';
import { usePrevious, useUpdateEffect } from 'react-use';
import { formatInstrumentNumber } from 'analytics/components/panels/utils/formatInstrumentNumber/formatInstrumentNumber';
import { HeatmapInstrumentTooltip, } from '../tooltip/heatmapInstrumentTooltip';
import styles from './heatmapInstrumentCell.module.scss';
export const HeatmapInstrumentCell = memo(function HeatmapInstrumentCell({ cell, dimmed = false, background = 'transparent', tooltipProps, textProps = {}, onMouseEnter, }) {
    const [animateChange, setAnimateChange] = useState(false);
    const prevValue = usePrevious(cell === null || cell === void 0 ? void 0 : cell.value);
    useUpdateEffect(() => {
        if ((cell === null || cell === void 0 ? void 0 : cell.value) !== prevValue) {
            setAnimateChange(true);
            const timeoutID = setTimeout(() => {
                setAnimateChange(false);
            }, 200);
            return () => {
                clearTimeout(timeoutID);
            };
        }
    }, [cell === null || cell === void 0 ? void 0 : cell.value]);
    const formattedValue = useMemo(() => {
        if (!cell)
            return null;
        const { value, format } = cell;
        if (typeof value === 'string') {
            return value;
        }
        if (typeof value === 'number' && format) {
            return formatInstrumentNumber(value, format);
        }
        return '—';
    }, [cell]);
    if (!cell) {
        return (_jsx("div", { className: styles.cell, onMouseEnter: onMouseEnter, "data-testid": "heatmap-instrument-cell" }));
    }
    const cellContent = (_jsx("div", Object.assign({ className: styles.cellContent }, { children: _jsx(Text.Paragraph, Object.assign({ className: classNames({
                [styles.cellText]: typeof cell.value === 'string',
            }), variant: "3", subdued: !isNumber(cell.value) }, textProps, { children: formattedValue })) })));
    return (_jsx("div", Object.assign({ className: classNames(styles.cell, {
            [styles.cellDimmed]: dimmed || animateChange,
        }), onMouseEnter: onMouseEnter, style: { background }, "data-animating": animateChange, "data-testid": "heatmap-instrument-cell" }, { children: (tooltipProps === null || tooltipProps === void 0 ? void 0 : tooltipProps.enabled) ? (_jsx(HeatmapInstrumentTooltip, Object.assign({}, tooltipProps, { children: cellContent }))) : (cellContent) })));
});
